import { FileRecordStatus } from "../../../common/types/FileRecordStatus";

export const isFileRecordRemovable = ({
    status,
    isNotificationApproved
}: {
    status: FileRecordStatus;
    isNotificationApproved: boolean;
}): boolean => {
    if (isNotificationApproved) {
        return false;
    }

    if ([FileRecordStatus.QcDone, FileRecordStatus.Destroyed].includes(status)) {
        return false;
    }

    return true;
};
